<div class="inner">
  @for (badge of safeBadges(); track 'label') {
    <rt-badge [color]="badge.color" [text]="badge.text" />
  }
</div>
